'use strict';

const Backbone = require('dibs-backbone');
const SoaModel = require('bunsen/models/SoaModel');
const endpoints = require('dibs-endpoints');

const SocialNetwork = require('../../models/identity/SocialNetwork');

const UserSocialNetwork = module.exports = SoaModel.extend();

Object.assign(UserSocialNetwork, {
    STATUS_CONNECTED: 'CONNECTED',
    STATUS_DELETED: 'DELETED'
});

Object.assign(UserSocialNetwork.prototype, {
    defaults: {
        socialNetwork: {},
        userPreferences: {},
        status: null
    },

    relations: [
        {
            key: 'socialNetwork',
            relatedModel: SocialNetwork,
            type: Backbone.One
        }
    ],

    getUserId() {
        return this.collection && this.collection.getUserId();
    },

    url() {
        if (this.isNew()) {
            const userId = this.getUserId();
            return endpoints.addUserSocialNetwork(userId);
        } else {
            return endpoints.userSocialNetwork(this.id);
        }
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/UserSocialNetwork.es.js